// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* header start */

.header {
  background-color: #ffff;
}

.tex-color-name {
  color: #ffff;
}

.toggleCircleButton {
  width: 20px;
  height: 20px;
  transition: left 0.3s linear;
  position: absolute;
  border-radius: 50%;
  background-color: #fff;
  top: 2px;
}

.toggleButtonTheme {
  width: 50px;
  height: 25px;
  border-radius: 20px;
  padding: 3px;
  overflow: hidden;
  /* Ensure the circle doesn't overflow the container */
}

/* Dropdown menus */
.dropdown-menu {
  border-radius: 4px;
  padding: 10px 0;
  animation-name: dropdown-animate;
  animation-duration: 0.2s;
  animation-fill-mode: both;
  border: 0;
  box-shadow: 0 5px 30px 0 rgba(82, 63, 105, 0.2);
}

.dropdown-menu .dropdown-header,
.dropdown-menu .dropdown-footer {
  text-align: center;
  font-size: 15px;
  padding: 10px 25px;
}

.dropdown-menu .dropdown-footer a {
  color: #444444;
  text-decoration: underline;
}

.dropdown-menu .dropdown-footer a:hover {
  text-decoration: none;
}

.dropdown-menu .dropdown-divider {
  color: #a5c5fe;
  margin: 0;
}

/* In your CSS file or inside a <style> tag */
.search-item {
  padding: 8px;
  cursor: pointer;
  background-color: white;
  border-bottom: 1px solid #eee;
  transition: background-color 0.2s ease;
}

.search-item:hover {
  background-color: #f0f0f0 !important;
}

@media (min-width: 768px) {
  .dropdown-menu-arrow::before {
    content: "";
    width: 13px;
    height: 13px;
    background: #fff;
    position: absolute;
    top: -7px;
    right: 20px;
    transform: rotate(45deg);
    border-top: 1px solid #eaedf1;
    border-left: 1px solid #eaedf1;
  }
}

@keyframes dropdown-animate {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }

  0% {
    opacity: 0;
  }
}

/* Light Backgrounds */
.bg-primary-light {
  background-color: #cfe2ff;
  border-color: #cfe2ff;
}

.bg-secondary-light {
  background-color: #e2e3e5;
  border-color: #e2e3e5;
}

.bg-success-light {
  background-color: #d1e7dd;
  border-color: #d1e7dd;
}

.bg-danger-light {
  background-color: #f8d7da;
  border-color: #f8d7da;
}

.bg-warning-light {
  background-color: #fff3cd;
  border-color: #fff3cd;
}

.bg-info-light {
  background-color: #cff4fc;
  border-color: #cff4fc;
}

.bg-dark-light {
  background-color: #d3d3d4;
  border-color: #d3d3d4;
}

/*--------------------------------------------------------------
# Header
--------------------------------------------------------------*/
.logo {
  line-height: 1;
}

@media (min-width: 1200px) {
  .logo {
    width: 280px;
  }
}

.logo img {
  max-height: 26px;
  margin: 10px;
}

.logo span {
  font-size: 26px;
  font-weight: 700;
  color: #012970;
  font-family: "Nunito", sans-serif;
}

.header .toggle-sidebar-btn {
  font-size: 32px;
  padding-left: 10px;
  cursor: pointer;
  color: #012970;
}

.username {
  font-size: 16px !important;
  color: #000000;
}

.username:hover {
  font-size: 16px;
  color: #000000;
}

.nav-portal {
  /* padding-left: 120px !important; */
}

.adminSideDropDown {
  display: none;
  flex-direction: column;
  position: absolute;
  right: 0;
  top: 68px;
  width: 160px;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  box-shadow: 0px 10px 11px -2px #0000002e;
  transition: all 0.2s ease;
}

.adminDropDownContainer.open .adminSideDropDown {
  display: flex;
}

.adminSideDropDown>li>a {
  font-size: 15px;
}

.adminSideDropDown>li>a>svg {}

@media (max-width: 1199px) {
  .header .search-bar {
    position: fixed;
    top: 50px;
    left: 0;
    right: 0;
    padding: 20px;
    box-shadow: 0px 0px 15px 0px rgba(1, 41, 112, 0.1);
    background: white;
    z-index: 9999;
    transition: 0.3s;
    visibility: hidden;
    opacity: 0;
  }

  .header .search-bar-show {
    top: 60px;
    visibility: visible;
    opacity: 1;
  }
}

.header .search-form {
  width: 100%;
}

.header .search-form input {
  border: 0;
  font-size: 14px;
  color: #012970;
  border: 1px solid rgba(1, 41, 112, 0.2);
  padding: 7px 38px 7px 8px;
  border-radius: 3px;
  transition: 0.3s;
  width: 100%;
}

.header .search-form input:focus,
.header .search-form input:hover {
  outline: none;
  box-shadow: 0 0 10px 0 rgba(1, 41, 112, 0.15);
  border: 1px solid rgba(1, 41, 112, 0.3);
}

.header .search-form button {
  border: 0;
  padding: 0;
  margin-left: -30px;
  background: none;
}

.header .search-form button i {
  color: #012970;
}

/*--------------------------------------------------------------
# Header Nav
--------------------------------------------------------------*/
.header-nav ul {
  list-style: none;
}

.header-nav>ul {
  margin: 0;
  padding: 0;
}

.header-nav .nav-icon {
  font-size: 22px;
  color: #012970;
  position: relative;
}

.header-nav .nav-profile {
  color: #012970;
}

.header-nav .nav-profile img {
  max-height: 36px;
}

.header-nav .nav-profile span {
  font-size: 16px;
  font-weight: 600;
}

.header-nav .badge-number {
  position: absolute;
  inset: 0px 5px auto auto;
  font-weight: normal;
  font-size: 12px;
  padding: 2px 5px;
}

.header-nav .notifications {
  inset: 8px -231px auto auto !important;
}

.header-nav .notifications .notification-item {
  display: flex;
  align-items: center;
  padding: 15px 10px;
  transition: 0.3s;
}

.header-nav .notifications .notification-item i {
  margin: 0 20px 0 10px;
  font-size: 24px;
}

.header-nav .notifications .notification-item h4 {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 5px;
}

.header-nav .notifications .notification-item p {
  font-size: 13px;
  margin-bottom: 3px;
  color: #919191;
}

.header-nav .notifications .notification-item:hover {
  background-color: #f6f9ff;
}

.header-nav .messages {
  inset: 8px -215px auto auto !important;
}

.header-nav .messages .message-item {
  padding: 15px 10px;
  transition: 0.3s;
}

.header-nav .messages .message-item a {
  display: flex;
}

.header-nav .messages .message-item img {
  margin: 0 20px 0 10px;
  max-height: 40px;
}

.header-nav .messages .message-item h4 {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 5px;
  color: #444444;
}

.header-nav .messages .message-item p {
  font-size: 13px;
  margin-bottom: 3px;
  color: #919191;
}

.header-nav .messages .message-item:hover {
  background-color: #f6f9ff;
}

.header-nav .profile {
  min-width: 240px;
  padding-bottom: 0;
  top: 8px !important;
}

.header-nav .profile .dropdown-header h6 {
  font-size: 18px;
  margin-bottom: 0;
  font-weight: 600;
  color: #444444;
}

.header-nav .profile .dropdown-header span {
  font-size: 14px;
}

.header-nav .profile .dropdown-item {
  font-size: 14px;
  padding: 8px 10px;
  transition: 0.3s;
}

.header-nav .profile .dropdown-item i {
  margin-right: 10px;
  font-size: 18px;
  line-height: 0;
}

.header-nav .profile .dropdown-item:hover {
  background-color: #f6f9ff;
}

.liveAlert {
  position: fixed;
  right: 0;
  z-index: 9999;
  top: 17px;
  right: 5px;
}

/* header end*/

.toggleButton {
  width: 50px;
  height: 50px;
}

.userText {
  font-size: 13px;
  font-weight: bold;
  min-width: 55px;
}

.alertNotification {
  position: fixed;
  z-index: 9999;
  top: 0;
  right: 0;
}

.adminRightNavbar {
  position: sticky;
  top: 0;
  z-index: 1;
}

.rightSideButton {
  border-radius: 30px;
}

.visitSite {
  background-color: rgb(19, 157, 242) !important;
  color: #000;
  font-weight: bold;
  border-radius: 5px;
}

.visitSite>a {
  color: #fff;
  font-size: 15px;
  font-weight: bold;
}

#external-svg {
  color: red;
  fill: red;
}

.home-hover-bg:hover {
  background-color: #f5f5f5;
  text-decoration: none;
}

.home-transition {
  transition: all 0.2s ease-in-out;
}

@media screen and (max-width: 768px) {
  .visitSite {
    background-color: transparent;
  }

  .visitSite>a>svg {
    color: #3698d3;
  }
}`, "",{"version":3,"sources":["webpack://./src/layout/Header/Header.css"],"names":[],"mappings":"AAAA,iBAAiB;;AAEjB;EACE,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,qDAAqD;AACvD;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,eAAe;EAEf,gCAAgC;EAEhC,wBAAwB;EAExB,yBAAyB;EACzB,SAAS;EACT,+CAA+C;AACjD;;AAEA;;EAEE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,SAAS;AACX;;AAEA,6CAA6C;AAC7C;EACE,YAAY;EACZ,eAAe;EACf,uBAAuB;EACvB,6BAA6B;EAC7B,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE;IACE,WAAW;IACX,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,wBAAwB;IACxB,6BAA6B;IAC7B,8BAA8B;EAChC;AACF;;AAgBA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA,sBAAsB;AACtB;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;+DAE+D;AAC/D;EACE,cAAc;AAChB;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,+BAA+B;EAC/B,gCAAgC;EAChC,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA,6BAA6B;;AAE7B;EACE;IACE,eAAe;IACf,SAAS;IACT,OAAO;IACP,QAAQ;IACR,aAAa;IACb,kDAAkD;IAClD,iBAAiB;IACjB,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,SAAS;IACT,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,uCAAuC;EACvC,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;;EAEE,aAAa;EACb,6CAA6C;EAC7C,uCAAuC;AACzC;;AAEA;EACE,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;;+DAE+D;AAC/D;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,SAAS;EACT,UAAU;AACZ;;AAEA,cAAc;;AAEd;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,MAAM;EACN,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8CAA8C;EAC9C,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE;IACE,6BAA6B;EAC/B;;EAEA;IACE,cAAc;EAChB;AACF","sourcesContent":["/* header start */\n\n.header {\n  background-color: #ffff;\n}\n\n.tex-color-name {\n  color: #ffff;\n}\n\n.toggleCircleButton {\n  width: 20px;\n  height: 20px;\n  transition: left 0.3s linear;\n  position: absolute;\n  border-radius: 50%;\n  background-color: #fff;\n  top: 2px;\n}\n\n.toggleButtonTheme {\n  width: 50px;\n  height: 25px;\n  border-radius: 20px;\n  padding: 3px;\n  overflow: hidden;\n  /* Ensure the circle doesn't overflow the container */\n}\n\n/* Dropdown menus */\n.dropdown-menu {\n  border-radius: 4px;\n  padding: 10px 0;\n  -webkit-animation-name: dropdown-animate;\n  animation-name: dropdown-animate;\n  -webkit-animation-duration: 0.2s;\n  animation-duration: 0.2s;\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n  border: 0;\n  box-shadow: 0 5px 30px 0 rgba(82, 63, 105, 0.2);\n}\n\n.dropdown-menu .dropdown-header,\n.dropdown-menu .dropdown-footer {\n  text-align: center;\n  font-size: 15px;\n  padding: 10px 25px;\n}\n\n.dropdown-menu .dropdown-footer a {\n  color: #444444;\n  text-decoration: underline;\n}\n\n.dropdown-menu .dropdown-footer a:hover {\n  text-decoration: none;\n}\n\n.dropdown-menu .dropdown-divider {\n  color: #a5c5fe;\n  margin: 0;\n}\n\n/* In your CSS file or inside a <style> tag */\n.search-item {\n  padding: 8px;\n  cursor: pointer;\n  background-color: white;\n  border-bottom: 1px solid #eee;\n  transition: background-color 0.2s ease;\n}\n\n.search-item:hover {\n  background-color: #f0f0f0 !important;\n}\n\n@media (min-width: 768px) {\n  .dropdown-menu-arrow::before {\n    content: \"\";\n    width: 13px;\n    height: 13px;\n    background: #fff;\n    position: absolute;\n    top: -7px;\n    right: 20px;\n    transform: rotate(45deg);\n    border-top: 1px solid #eaedf1;\n    border-left: 1px solid #eaedf1;\n  }\n}\n\n@-webkit-keyframes dropdown-animate {\n  0% {\n    opacity: 0;\n  }\n\n  100% {\n    opacity: 1;\n  }\n\n  0% {\n    opacity: 0;\n  }\n}\n\n@keyframes dropdown-animate {\n  0% {\n    opacity: 0;\n  }\n\n  100% {\n    opacity: 1;\n  }\n\n  0% {\n    opacity: 0;\n  }\n}\n\n/* Light Backgrounds */\n.bg-primary-light {\n  background-color: #cfe2ff;\n  border-color: #cfe2ff;\n}\n\n.bg-secondary-light {\n  background-color: #e2e3e5;\n  border-color: #e2e3e5;\n}\n\n.bg-success-light {\n  background-color: #d1e7dd;\n  border-color: #d1e7dd;\n}\n\n.bg-danger-light {\n  background-color: #f8d7da;\n  border-color: #f8d7da;\n}\n\n.bg-warning-light {\n  background-color: #fff3cd;\n  border-color: #fff3cd;\n}\n\n.bg-info-light {\n  background-color: #cff4fc;\n  border-color: #cff4fc;\n}\n\n.bg-dark-light {\n  background-color: #d3d3d4;\n  border-color: #d3d3d4;\n}\n\n/*--------------------------------------------------------------\n# Header\n--------------------------------------------------------------*/\n.logo {\n  line-height: 1;\n}\n\n@media (min-width: 1200px) {\n  .logo {\n    width: 280px;\n  }\n}\n\n.logo img {\n  max-height: 26px;\n  margin: 10px;\n}\n\n.logo span {\n  font-size: 26px;\n  font-weight: 700;\n  color: #012970;\n  font-family: \"Nunito\", sans-serif;\n}\n\n.header .toggle-sidebar-btn {\n  font-size: 32px;\n  padding-left: 10px;\n  cursor: pointer;\n  color: #012970;\n}\n\n.username {\n  font-size: 16px !important;\n  color: #000000;\n}\n\n.username:hover {\n  font-size: 16px;\n  color: #000000;\n}\n\n.nav-portal {\n  /* padding-left: 120px !important; */\n}\n\n.adminSideDropDown {\n  display: none;\n  flex-direction: column;\n  position: absolute;\n  right: 0;\n  top: 68px;\n  width: 160px;\n  border-bottom-left-radius: 10px;\n  border-bottom-right-radius: 10px;\n  box-shadow: 0px 10px 11px -2px #0000002e;\n  transition: all 0.2s ease;\n}\n\n.adminDropDownContainer.open .adminSideDropDown {\n  display: flex;\n}\n\n.adminSideDropDown>li>a {\n  font-size: 15px;\n}\n\n.adminSideDropDown>li>a>svg {}\n\n@media (max-width: 1199px) {\n  .header .search-bar {\n    position: fixed;\n    top: 50px;\n    left: 0;\n    right: 0;\n    padding: 20px;\n    box-shadow: 0px 0px 15px 0px rgba(1, 41, 112, 0.1);\n    background: white;\n    z-index: 9999;\n    transition: 0.3s;\n    visibility: hidden;\n    opacity: 0;\n  }\n\n  .header .search-bar-show {\n    top: 60px;\n    visibility: visible;\n    opacity: 1;\n  }\n}\n\n.header .search-form {\n  width: 100%;\n}\n\n.header .search-form input {\n  border: 0;\n  font-size: 14px;\n  color: #012970;\n  border: 1px solid rgba(1, 41, 112, 0.2);\n  padding: 7px 38px 7px 8px;\n  border-radius: 3px;\n  transition: 0.3s;\n  width: 100%;\n}\n\n.header .search-form input:focus,\n.header .search-form input:hover {\n  outline: none;\n  box-shadow: 0 0 10px 0 rgba(1, 41, 112, 0.15);\n  border: 1px solid rgba(1, 41, 112, 0.3);\n}\n\n.header .search-form button {\n  border: 0;\n  padding: 0;\n  margin-left: -30px;\n  background: none;\n}\n\n.header .search-form button i {\n  color: #012970;\n}\n\n/*--------------------------------------------------------------\n# Header Nav\n--------------------------------------------------------------*/\n.header-nav ul {\n  list-style: none;\n}\n\n.header-nav>ul {\n  margin: 0;\n  padding: 0;\n}\n\n.header-nav .nav-icon {\n  font-size: 22px;\n  color: #012970;\n  position: relative;\n}\n\n.header-nav .nav-profile {\n  color: #012970;\n}\n\n.header-nav .nav-profile img {\n  max-height: 36px;\n}\n\n.header-nav .nav-profile span {\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.header-nav .badge-number {\n  position: absolute;\n  inset: 0px 5px auto auto;\n  font-weight: normal;\n  font-size: 12px;\n  padding: 2px 5px;\n}\n\n.header-nav .notifications {\n  inset: 8px -231px auto auto !important;\n}\n\n.header-nav .notifications .notification-item {\n  display: flex;\n  align-items: center;\n  padding: 15px 10px;\n  transition: 0.3s;\n}\n\n.header-nav .notifications .notification-item i {\n  margin: 0 20px 0 10px;\n  font-size: 24px;\n}\n\n.header-nav .notifications .notification-item h4 {\n  font-size: 16px;\n  font-weight: 600;\n  margin-bottom: 5px;\n}\n\n.header-nav .notifications .notification-item p {\n  font-size: 13px;\n  margin-bottom: 3px;\n  color: #919191;\n}\n\n.header-nav .notifications .notification-item:hover {\n  background-color: #f6f9ff;\n}\n\n.header-nav .messages {\n  inset: 8px -215px auto auto !important;\n}\n\n.header-nav .messages .message-item {\n  padding: 15px 10px;\n  transition: 0.3s;\n}\n\n.header-nav .messages .message-item a {\n  display: flex;\n}\n\n.header-nav .messages .message-item img {\n  margin: 0 20px 0 10px;\n  max-height: 40px;\n}\n\n.header-nav .messages .message-item h4 {\n  font-size: 16px;\n  font-weight: 600;\n  margin-bottom: 5px;\n  color: #444444;\n}\n\n.header-nav .messages .message-item p {\n  font-size: 13px;\n  margin-bottom: 3px;\n  color: #919191;\n}\n\n.header-nav .messages .message-item:hover {\n  background-color: #f6f9ff;\n}\n\n.header-nav .profile {\n  min-width: 240px;\n  padding-bottom: 0;\n  top: 8px !important;\n}\n\n.header-nav .profile .dropdown-header h6 {\n  font-size: 18px;\n  margin-bottom: 0;\n  font-weight: 600;\n  color: #444444;\n}\n\n.header-nav .profile .dropdown-header span {\n  font-size: 14px;\n}\n\n.header-nav .profile .dropdown-item {\n  font-size: 14px;\n  padding: 8px 10px;\n  transition: 0.3s;\n}\n\n.header-nav .profile .dropdown-item i {\n  margin-right: 10px;\n  font-size: 18px;\n  line-height: 0;\n}\n\n.header-nav .profile .dropdown-item:hover {\n  background-color: #f6f9ff;\n}\n\n.liveAlert {\n  position: fixed;\n  right: 0;\n  z-index: 9999;\n  top: 17px;\n  right: 5px;\n}\n\n/* header end*/\n\n.toggleButton {\n  width: 50px;\n  height: 50px;\n}\n\n.userText {\n  font-size: 13px;\n  font-weight: bold;\n  min-width: 55px;\n}\n\n.alertNotification {\n  position: fixed;\n  z-index: 9999;\n  top: 0;\n  right: 0;\n}\n\n.adminRightNavbar {\n  position: sticky;\n  top: 0;\n  z-index: 1;\n}\n\n.rightSideButton {\n  border-radius: 30px;\n}\n\n.visitSite {\n  background-color: rgb(19, 157, 242) !important;\n  color: #000;\n  font-weight: bold;\n  border-radius: 5px;\n}\n\n.visitSite>a {\n  color: #fff;\n  font-size: 15px;\n  font-weight: bold;\n}\n\n#external-svg {\n  color: red;\n  fill: red;\n}\n\n.home-hover-bg:hover {\n  background-color: #f5f5f5;\n  text-decoration: none;\n}\n\n.home-transition {\n  transition: all 0.2s ease-in-out;\n}\n\n@media screen and (max-width: 768px) {\n  .visitSite {\n    background-color: transparent;\n  }\n\n  .visitSite>a>svg {\n    color: #3698d3;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
